if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function() {
  // Select the plus and minus buttons and the quantity input element
const plusButton = document.querySelector('.quantity__button[name="plus"]');
const minusButton = document.querySelector('.quantity__button[name="minus"]');
const quantityElement = document.querySelector('.quantity__input');
if(plusButton && minusButton && quantityElement){
  // Event listener for the plus button
plusButton.addEventListener('click', function() {
 const currentQuantity = parseInt(quantityElement.value);
  updateQuantity(currentQuantity);
});

// Event listener for the minus button
minusButton.addEventListener('click', function() {
 const currentQuantity = parseInt(quantityElement.value);
  updateQuantity(currentQuantity);
});  

quantityElement.addEventListener('input',function(){
  const currentQuantity=parseInt(quantityElement.value);
  updateQuantity(currentQuantity);
})

// Function to update the quantity
function updateQuantity(currentQuantity) {
  // console.log('currentQuantity', currentQuantity);
  const stickyElement = document.querySelector('.Sticky_AddToCart .quantity .quantity__input');
  quantityElement.value = currentQuantity;
  stickyElement.value = currentQuantity;
}
}
});

document.addEventListener("DOMContentLoaded", function() {
  // Select the main sticky add-to-cart element
  const stickyElementMain = document.querySelector('.Sticky_AddToCart');
 if(stickyElementMain){
  // Event listener for any click within the sticky add-to-cart element
  stickyElementMain.addEventListener('click', function(event) {
    const target =event.target;
     // Check if the click was on a plus or minus button within the sticky add-to-cart element
    const plusButton = target.closest('.Sticky_AddToCart .quantity__button[name="plus"]');
    const minusButton = target.closest('.Sticky_AddToCart .quantity__button[name="minus"]');
    const quantityElement = document.querySelector('.Sticky_AddToCart .quantity .quantity__input');
    const  stickyElement=document.querySelector('.quantity__input');
    
    if(plusButton){
      const  currentQuantity = parseInt(quantityElement.value);
      updateQuantity(currentQuantity );
    }else if(minusButton){
      const  currentQuantity = parseInt(quantityElement.value);
      updateQuantity(currentQuantity);
    }

    quantityElement.addEventListener('input',function(){
      const currentQuantity=parseInt(quantityElement.value);
      updateQuantity(currentQuantity);
    })

        // Function to update the quantity
    function updateQuantity(currentQuantity) {
      // console.log('currentQuantity', currentQuantity);
      quantityElement.value = currentQuantity;
      stickyElement.value = currentQuantity;
    }
  });
 }
});